module.exports = __webpack_public_path__ + "img/paint-08.75f4b7ee.png";